import TcVod from 'vod-js-sdk-v6'
import { Controller } from '@hotwired/stimulus'
import { DirectUpload} from '@rails/activestorage';
import {FileChecksum} from '../libs/file_checksum'
import { post } from '@rails/request.js'
export default class extends Controller {
  connect() {
    console.log("connect")
  }

  upload() {
    console.log("upload", this.element)
    // this.createThing("test", this.element.files[0])
    const file = this.element.files[0]
    FileChecksum.create(file, (error, checksum) => {
      if (error) {
        console.log(error)
        return
      } else {
        console.log(checksum)
        this.uploadBlob(file, checksum)
      }
    })
  }


  uploadVideo = (file) => {
    const tcVod = new TcVod({
      ak: 'ak',
      sk: 'sk',
    })
    const uploader = tcVod.upload({
      mediaFile: file, // 媒体文件（视频或音频或图片），类型为 File
      checksum: base64digest,
    })  // 媒体文件（视频或音频或图片),类型为 File
    uploader.on('media_progress', function(info) {

    })  // 媒体文件上传进度
    uploader.on('media_upload', function(info) {
      console.log(info)
    })  // 媒体文件上传成功
  }

  uploadBlob = async  (file, checksum) => { // name is a string, the_attachment is a File object
    const blob = {
      filename: file.name,
      content_type: file.type || "application/octet-stream",
      byte_size: file.size,
      checksum: checksum
    }
    // const body = {
    //   blob: JSON.stringify(blob)
    // }
    const response = await post("/api/v1/video_uploads",{ body: {blob} })
    const json = await response.json
    console.log(json)
    const signed_id = json.signed_id
    document.getElementById("video_file_signed_id").value = signed_id
  };
}
